import type { GetLoanTransactionsQuery } from '../../../../__generated__/graphql/api';

type RawTransactions = NonNullable<NonNullable<GetLoanTransactionsQuery['loanTransactions']>['transactions']>;

export type RawTransaction = NonNullable<RawTransactions[number]>;

export interface UserTransactionListItem {
  id: string;
  amount: string | null;
  effectiveDate: string | null;
  transmissionDate: string | null;
  transactionType: string | null;
  direction: string | null;
  status: string | null;
  merchantName: string | null;
  merchantLocation: string | null;
  ledgerOnly: boolean;
}

const buildMerchantLocation = (city: string | null | undefined, region: string | null | undefined) => {
  const parts = [city, region].filter(Boolean);

  return parts.length === 0 ? null : parts.join(', ');
};

export const toUserTransactionListItem = (
  txn: RawTransaction,
  options: { ledgerOnly?: boolean } = {},
): UserTransactionListItem => ({
  id: txn.id ?? '',
  amount: txn.amount ?? null,
  effectiveDate: txn.effectiveDate ?? null,
  transmissionDate: txn.transmissionDate ?? null,
  transactionType: txn.transactionType ?? null,
  direction: txn.direction ?? null,
  status: txn.status ?? null,
  merchantName: txn.merchantDetails?.displayName ?? txn.merchantDetails?.name ?? null,
  merchantLocation: buildMerchantLocation(txn.merchantDetails?.city, txn.merchantDetails?.region),
  ledgerOnly: options.ledgerOnly ?? false,
});

export const buildClientTransactionMatchKey = (txn: RawTransaction): string => {
  if (txn.id) return `id:${txn.id}`;

  return [txn.transmissionDate ?? '', txn.effectiveDate ?? '', txn.amount ?? '', txn.transactionType ?? ''].join('|');
};
